import type { VerifyMfaBody } from "./auth.api";
import type { Organization, SipConfigurationInsert } from "@/schemas/organization.schema";
import type { UserSettings } from "@/schemas/settings.schema";
import { api } from "@/services/api";

export const settingsApi = {
  async updateUserSettings(user: Partial<UserSettings>) {
    await api.post("/settings/user", user);
  },

  async updateOrganizationSettings(organization: Partial<Pick<Organization, "name" | "settings">>) {
    await api.post("/settings/organization", organization);
  },

  async updateSipSettings(config: SipConfigurationInsert) {
    await api.post("/settings/sip-configuration", config);
  },

  async generateMfa() {
    const { data } = await api.post<{
      qr_code: string;
    }>("/settings/mfa/generate");

    return data;
  },

  async verifyMfa(code: string) {
    const { data } = await api.post<{
      recovery_code: string;
    }>("/settings/mfa/verify", { code });

    return data;
  },

  async enableMfa(recovery_code: string) {
    await api.post("/settings/mfa/enable", { recovery_code });
  },

  async disableMfa(body: VerifyMfaBody) {
    await api.post("/settings/mfa/disable", body);
  },

  async logoutAll() {
    await api.post("/settings/logout-all");
  },
};
